import assignIn from 'lodash/assignIn'
import cloneDeep from 'lodash/cloneDeep'
import each from 'lodash/each'

class Form {
  constructor(values) {
    this.$errorMessage = ''
    this.$errors = {}
    this.$busy = false

    this.$originalData = cloneDeep(values)
    assignIn(this, values)
  }

  $data() {
    let data = cloneDeep(this.$originalData)
    each(this.$originalData, (_, key) => {
      data[key] = this[key]
    })

    return data
  }

  $reset() {
    assignIn(this, this.$originalData)
    this.$clearErrors()
  }

  $setLoading(bool) {
    this.$busy = bool
    if (bool) {
      this.$clearErrors()
    }
  }

  $isLoading() {
    return this.$busy
  }

  $setError(field, errors) {
    let tmp = cloneDeep(this.$errors)
    tmp[field] = errors
    this.$errors = tmp
  }

  $setErrors(errors) {
    this.$errors = errors
  }

  $getError(field) {
    return this.$errors[field]
  }

  $clearErrors() {
    this.$errors = {}
    this.$errorMessage = ''
  }

  $clearError(field) {
    let tmp = cloneDeep(this.$errors)
    delete tmp[field]
    this.$errors = tmp
  }

  $hasError(field) {
    return !!this.$errors[field]
  }

  $setErrorMessage(message) {
    this.$errorMessage = message
  }

  $handleError(error) {
    this.$busy = false
    if (!error.response) {
      // console.log(error)
    } else if (error.response.status === 422) {
      this.$errors = error.response.data.errors
      this.$errorMessage = 'There are items that require your attention'
    } else if (error.response.status === 500) {
      this.$errorMessage =
        'Sorry, something went wrong. Try again later or contact us if the problem persists'
    } else {
      this.$errorMessage = error.response.data.message
    }
  }
}

export default Form
